import { httpClient } from '../common/httpclient';

export const EXPENSE_STATUS = {
    PENDENTE: 'Pendente',
    PRESTADO_CONTAS: 'Prestado Contas'
};

function errorMessageFromResponse(res) {
    const data = res.data;
    if (typeof data === 'string' && data.trim()) return data.trim();
    if (data && typeof data === 'object' && data.message != null) return String(data.message);
    if (data && typeof data === 'object' && data.error != null) return String(data.error);
    return res.statusText || `Erro (${res.status})`;
}

/**
 * @param {{ id: string, status: string, payment_date?: string }} body
 * @returns {Promise<void>}
 */
export async function updateExpenseStatus(body) {
    const { id, status, payment_date } = body;
    if (status === EXPENSE_STATUS.PRESTADO_CONTAS && !String(payment_date || '').trim()) {
        throw new Error('Informe a data de pagamento para Prestado Contas.');
    }
    const payload = { id, status };
    if (status === EXPENSE_STATUS.PRESTADO_CONTAS) {
        payload.payment_date = String(payment_date).trim();
    }
    const res = await httpClient.put('/transactions/expense', payload);
    if (res.status === 204) return;
    throw new Error(errorMessageFromResponse(res));
}
